import classnames from "classnames";
import React, { ReactNode } from "react";
import styled from "styled-components";

interface IBackground {
  background?: string;
}

const Container = styled.div`
  z-index: 100;
  display: none;

  position: fixed;
  overflow: hidden;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;

  img {
    height: auto;
    max-width: 100%;
  }

  &.show {
    display: block;
  }
`;

const Mask = styled.div<IBackground>`
  position: absolute;
  width: 100%;
  height: 100%;
  cursor: pointer;
  background: ${({ background }: IBackground): string =>
    background || "rgba(255, 255, 255, 0.7)"};
`;

interface IProps {
  children: ReactNode;
  onMaskClick: () => void;
  open: boolean;
  className?: string;
  background?: string;
}

export const Modal = ({
  children,
  onMaskClick,
  open,
  className,
  background,
}: IProps): JSX.Element => {
  return (
    <Container className={classnames({ show: open }, className)}>
      <Mask onClick={onMaskClick} background={background} />

      {children}
    </Container>
  );
};
